import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import OurService from './pages/OurService';
import Gallery from './pages/Gallery';
import ContactUs from './pages/Contact';
import WaterTreatmentPage from './pages/WTP';
import FRP from './pages/FRP';
import IDS from './pages/Industrial_domestic_softener';
import STP from './pages/STP';
import PSF from './pages/PSF';
import ETP from './pages/ETP';
import UF from './pages/UF';
import RO from './pages/RO';
import ScrollToTop from './components/ScrollToTop';


function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<OurService />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/WTP" element={<WaterTreatmentPage />} />
          <Route path='/FRP' element={<FRP />} />
          <Route path='/IDS' element={<IDS />} />
          <Route path='/STP' element={<STP />} />
          <Route path='/PSF' element={<PSF />} />
          <Route path='/ETP' element={<ETP />} />
          <Route path='/UF' element={<UF />} />
          <Route path='/RO' element={<RO />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
